<template>
    <div class="search-bar search-bar-center template6">
        <div class="search-by-section">
            <div class="search-category">
                <div class="keyword">
                    <input
                        class="search-input"
                        type="text"
                        v-model="keyword"
                        :placeholder="searchPlaceholder"
                        @input="inputValue"
                        @click="setshowSearchList(true, $event)"
                        @keyup.enter="handleEnter"
                        :aria-label="searchPlaceholder || 'Search keyword'"
                    />
                </div>
                <div
                    class="keyword-submit"
                    @click="handleSearch"
                    role="button"
                    tabindex="0"
                    :aria-label="submitText || 'Search'"
                >
                    <i class="iconfont icon-search-medium" aria-hidden="true"></i>
                </div>
            </div>

            <ul
                class="search-list-panel mg-scrollbar"
                v-show="showSearchList && keyWordSuggestion.length > 0"
                v-outsideclick="outsideClick"
            >
                <li
                    v-for="(item, index) in keyWordSuggestion"
                    :class="`search-list-item ${
                        item.value ? 'item-type' : 'item-title'
                    }`"
                    :key="index"
                    @click="selectSuggestion(item.value, item.type)"
                >
                    {{ item.label }}
                </li>
            </ul>
        </div>
        <div
            class="condition-search"
            v-if="needSearchCondition"
        >
            <ul class="condition-wrap others">
                <li
                    v-for="item in otherSplitFilterConfigs"
                    class="condition-item"
                    :key="item.name"
                >
                    <p class="cell-title">{{ item.label }}</p>
                    <Range
                        v-if="item.inputType == 'inputBox'"
                        cls="search-detail-item"
                        :kee="item.name"
                        :label="''"
                        :key="item.name"
                        :args="item.args"
                        :icon="item.icon"
                        :mask="item.mask"
                        :emptyLabel="$t('md-hero.any')"
                        :dropdown="true"
                        :value="
                            (conditions[item.name] &&
                                conditions[item.name].value) ||
                                ''
                        "
                        @open="showStartPriceList = showEndPriceList = false"
                        @change="updateCondition"
                        maxlength="9"
                    />
                    <Select
                        v-if="
                            item.inputType == 'multiSelect' ||
                                item.inputType == 'singleSelect'
                        "
                        cls="search-detail-item"
                        :multiple="item.inputType == 'multiSelect'"
                        :label="$t('md-hero.any')"
                        :kee="item.name"
                        :key="item.name"
                        :options="item.args"
                        :icon="item.icon"
                        :show_count="false"
                        :value="
                            (conditions[item.name] &&
                                conditions[item.name].value) ||
                                ''
                        "
                        :getOptionsAsync="true"
                        @changeOptions="
                            list => {
                                changeOptions(list, item);
                            }
                        "
                        @open="showStartPriceList = showEndPriceList = false"
                        @change="updateCondition"
                    />
                </li>
            </ul>
            <ul
                class="condition-wrap price"
                v-if="priceSplitFilterConfigs.length > 0"
            >
                <p class="cell-title">
                    {{ priceConfig && priceConfig.label }}
                </p>
                <li
                    v-for="item in priceSplitFilterConfigs"
                    class="condition-item condition-item-price"
                    :key="item.name"
                >
                    <div class="condition-price">
                        <div class="price-input-wrap">
                            <input
                                class="price-input"
                                type="text"
                                v-model="startPrice"
                                @input="inputPrice('startPrice', $event)"
                                @click="showPriceList('showStartPriceList', $event)"
                                @blur="switchPrice"
                                maxlength="13"
                                :aria-label="
                                    (priceConfig.args &&
                                        priceConfig.args.minTitle) ||
                                        'Minimum price'
                                "
                                :placeholder="
                                    (priceConfig.args &&
                                        priceConfig.args.minTitle) ||
                                        ''
                                "
                            />
                            <ul
                                class="price-list-panel"
                                v-show="showStartPriceList"
                                v-outsideclick="closeStartPriceListPannel"
                            >
                                <li @click="setPriceRange('startPrice', '')">
                                    <span>{{ $t('md-hero.any') }}</span>
                                </li>
                                <li
                                    v-for="price in item.args.options[0]"
                                    :key="price.value"
                                    @click="
                                        setPriceRange('startPrice', price.value)
                                    "
                                >
                                    <span>{{
                                        $ft.formatCurrency({
                                            value: price.label,
                                            currencySymbol
                                        })
                                    }}</span>
                                </li>
                            </ul>
                        </div>
                        <span class="price-line"></span>
                        <div class="price-input-wrap">
                            <input
                                class="price-input"
                                type="text"
                                v-model="endPrice"
                                @input="inputPrice('endPrice', $event)"
                                @click="showPriceList('showEndPriceList', $event)"
                                @blur="switchPrice"
                                maxlength="13"
                                :aria-label="
                                    $t('md-hero.pleaseEnterTheHighest')
                                "
                                :placeholder="
                                    (priceConfig.args &&
                                        priceConfig.args.maxTitle) ||
                                        ''
                                "
                            />
                            <ul
                                class="price-list-panel end-panel"
                                v-show="showEndPriceList"
                                v-outsideclick="closeEndPriceListPannel"
                            >
                                <li @click="setPriceRange('endPrice', '')">
                                    <span>{{ $t('md-hero.any') }}</span>
                                </li>
                                <li
                                    v-for="price in item.args.options[1]"
                                    :key="price.value"
                                    @click="
                                        setPriceRange('endPrice', price.value)
                                    "
                                >
                                    <span>{{
                                        $ft.formatCurrency({
                                            value: price.label,
                                            currencySymbol
                                        })
                                    }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <div
            class="keyword-submit"
            @click="handleSearch"
            role="button"
            tabindex="0"
            :aria-label="submitText || 'Search'"
        >
            <i class="iconfont icon-search-medium" aria-hidden="true"></i>
        </div>
        <div
            v-if="agreementData && agreementData.agreement"
            class="agreement-container"
        >
            <a
                :href="agreementData.agreementUrl || ''"
                class="agreement"
                target="_blank"
                rel="noopener noreferrer"
            >{{ agreementData.agreement }}</a>
        </div>
    </div>
</template>

<script>
import common from '../search-bar-center';
export default {
    mixins: [common],
};
</script>
<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';

.search-bar.template6 {
    width: 100%;
    position: relative;
    padding: 30px;
    border-radius: 4px;
    box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.1);
    background-color: #252525;
    .keyword-submit {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 60px;
        height: 60px;
        line-height: 60px;
        font-family: var(--mg-button-font);
        text-align: center;
        cursor: pointer;
        @include color-button-hover();
        @include color-button();
        .iconfont {
            font-size: 24px;
        }
    }
    > .keyword-submit {
        display: none;
    }
    @mixin search-bar_column {
        .search-by-section {
            .search-category {
                position: relative;
                .keyword {
                    .search-input {
                        padding-left: 20px;
                    }
                }
                .keyword-submit {
                    @include color-button-hover();
                    @include color-button();
                    width: 60px;
                    height: 60px;
                    .iconfont {
                        color: #fff;
                        font-size: 24px;
                    }
                }
            }
        }
    }
    &.column {
        @include search-bar_column;
    }
    @include media-1080 {
        &.row2column {
            @include search-bar_column;
        }
    }
    input[type='text'] {
        font-family: var(--font-normal);
        box-shadow: none;

        &:focus {
            outline: none;
            border: 1px solid var(--color-border);
        }
    }
    .search-by-section {
        position: relative;
        width: 100%;
        margin: 0 auto;

        .search-category {
            display: flex;
            align-items: center;
            font-size: 14px;
            .keyword {
                flex: 1;
                height: 100%;
                position: relative;
                .icon-search {
                    position: absolute;
                    left: 16px;
                    top: 50%;
                    transform: translateY(-50%);
                    font-size: 20px;
                    color: var(--color-holder);
                }
                .search-input {
                    width: 100%;
                    height: 60px;
                    padding-left: 20px;
                    font-size: 16px;
                    line-height: 20px;
                    color: #fff;
                    text-overflow: ellipsis;
                    -webkit-appearance: none;
                    border: 1px solid #505050;
                    border-right: none;
                    background-color: #252525;
                }
            }
        }

        .address-input {
            width: 100%;
            margin: 0;
        }

        .search-list-panel {
            z-index: 1000;
            position: absolute;
            left: 0;
            top: 63px;
            padding: 10px 0;
            width: 100%;
            max-height: 300px;
            overflow-y: auto;
            background-color: #252525;
            border: 1px solid #505050;

            .search-list-item {
                height: 32px;
                line-height: 32px;
                color: #ababab;
                @include ellipsis();

                &.item-title {
                    text-transform: capitalize;
                    font-family: var(--font-medium);
                    padding-left: 10px;
                }

                &.item-type {
                    padding: 0 10px 0 20px;
                    cursor: pointer;
                }
            }
        }
    }
    .condition-search {
        width: 100%;
        margin-top: 30px;

        .condition-wrap {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-wrap: nowrap;
            font-size: 16px;
            color: #515666;
            &.price {
                margin-top: 20px;
                > .cell-title {
                    font-size: 16px;
                    line-height: 20px;
                    color: #fff;
                }
                > .condition-item {
                    margin-right: 0;
                    margin-left: 15px;
                    .price-list-panel {
                        padding: 6px 10px 0 10px;
                    }
                }
            }
            &.others {
                .condition-item {
                    display: flex;
                    align-items: center;
                    position: relative;
                    justify-content: space-between;
                    .click-show-list {
                        position: unset;
                    }
                }
            }
            .icon-arrow-down {
                font-size: 12px;
                color: #c6c8d1;
                margin-right: 5px;
            }
            .condition-item {
                margin-left: 30px;
                width: 0;
                flex: 1;
                position: relative;

                &:first-child {
                    margin-left: 0;
                }
                &:last-child {
                    margin-right: 0;
                }

                .cell-title {
                    font-family: var(--font-normal);
                    font-size: 16px;
                    line-height: 20px;
                    color: #fff;
                }

                .search-detail-item {
                    background-color: #252525;
                    width: 110px;
                    color: #ababab;
                    height: 40px;
                    line-height: 40px;
                    align-items: center;

                    @media (min-width: 1260px) and (max-width: 1440px) {
                        min-width: 85px;

                        &.select {
                            min-width: 100px;
                        }
                    }

                    .name {
                        display: none;
                    }

                    .box-div {
                        width: 100%;
                        height: 100%;
                        padding-left: 10px;

                        .title {
                            height: 100%;
                            flex: 1;
                            display: flex;
                            overflow: hidden;
                            cursor: pointer;
                            color: #fff;

                            span:last-child {
                                float: right;
                                margin-right: 10px;
                            }
                            .text {
                                flex: 1;
                                margin-right: 10px;
                                text-align: right;
                                @include ellipsis();
                            }

                            .logo {
                                display: none;
                            }
                        }

                        .panel-style {
                            position: absolute;
                            z-index: var(--level-subhigh);
                            width: 200px;
                            left: 0;
                            max-height: 300px;
                            padding: 6px 10px 0 10px;
                            overflow-y: auto;
                            background: #252525;
                            border: 1px solid #505050;
                            box-sizing: border-box;
                            color: #ababab;
                            li {
                                line-height: 40px;
                                cursor: pointer;
                                height: 40px;
                                display: block;
                                overflow: hidden;
                                &:hover {
                                    color: #fff;
                                }
                                & > span {
                                    display: inline-block;
                                    width: calc(100% - 30px);

                                    @include ellipsis();
                                }
                                .iconfont {
                                    display: none;
                                    float: right;
                                    font-size: 14px;
                                }
                                &.selected {
                                    color: var(--color-theme, #dbae77);
                                    .iconfont {
                                        display: block;
                                    }
                                }
                            }
                        }

                        .split-line {
                            height: 30px;
                            width: 1px;
                            background-color: var(--color-border);
                        }

                        .logo {
                            display: none;
                        }

                        .icon-arrow-down {
                            margin-right: 10px;
                        }

                        .range-input-parent {
                            width: calc(100% - 50px);
                            &.box-div {
                                display: flex;
                                align-items: center;
                                cursor: auto;

                                .text {
                                    margin-right: 6px;
                                    cursor: default;
                                    flex: inherit;
                                }
                            }

                            &.list-panel {
                                position: absolute;
                                z-index: 1000;
                                display: flex;
                                justify-content: space-between;
                                left: 0;
                                width: 390px;
                                padding: 6px 10px;
                                box-shadow: 0 2px 5px 0 rgba(0, 10, 30, 0.1);
                                border: 1px solid #505050;
                                background-color: #252525;

                                .input-container {
                                    width: 175px;
                                    margin: 0;
                                    line-height: normal;
                                    .list-panel {
                                        position: relative;
                                        top: 0;
                                        left: 0;
                                        margin-top: 10px;
                                        padding: 0;
                                        color: #ababab;
                                        background-color: #252525;
                                        border: none;
                                        &.disabled {
                                            cursor: not-allowed;
                                            opacity: 0.4;
                                            &:after {
                                                content: '';
                                                position: absolute;
                                                top: 0;
                                                left: 0;
                                                width: 100%;
                                                height: 100%;
                                                z-index: 1;
                                            }
                                        }

                                        li {
                                            height: 40px;
                                            line-height: 40px;
                                            span {
                                                width: 100%;
                                                padding: 0;
                                            }
                                        }
                                    }
                                }
                            }

                            .price-line {
                                width: 10px;
                                height: 2px;
                                background-color: #505050;
                                display: inline-block;
                                margin: 20px 5px 0 5px;
                            }

                            .input-container {
                                position: relative;
                                height: 100%;
                                margin: 0 10px;
                                .input-label {
                                    font-size: 14px;
                                    line-height: 16px;
                                    margin-bottom: 8px;
                                }

                                .list-panel {
                                    left: 0;
                                    right: -50px;
                                    width: inherit;
                                }

                                input {
                                    width: 175px;
                                    height: 44px;
                                    padding: 0 10px;
                                    background-color: #191919;
                                    border: none;
                                    color: #ababab;
                                    line-height: 14px;
                                }

                                &.show-list {
                                    input {
                                        outline: none;
                                        border: 1px solid;
                                        @include color-theme('border-color');
                                    }
                                }

                                &.input_1 {
                                    margin-right: 0;
                                }
                            }
                        }
                    }
                }
            }

            .condition-price {
                display: flex;
                align-items: center;
                .price-title {
                    margin-right: 6px;
                }

                .price-input-wrap {
                    flex: 1;
                    display: flex;
                    position: relative;
                    .price-input {
                        width: 100%;
                        height: 40px;
                        color: #ababab;
                        border: solid 1px #505050;
                        background-color: #252525;
                        padding: 0 10px;
                        font-size: 14px;
                        line-height: 18px;
                    }

                    .price-list-panel {
                        position: absolute;
                        top: 43px;
                        left: 0;
                        width: 100%;
                        max-height: 300px;
                        color: #ababab;
                        border: 1px solid #505050;
                        overflow-y: auto;
                        background-color: #252525;
                        z-index: var(--level-subhigh);
                        li {
                            height: 40px;
                            line-height: 40px;
                            overflow: hidden;
                            cursor: pointer;
                            &:hover {
                                color: #fff;
                            }
                        }
                    }
                }

                .price-line {
                    display: inline-block;
                    width: 25px;
                    height: 2px;
                    margin: 0 16px;
                    background-color: #505050;
                }
            }
        }
    }
    .agreement-container {
        width: 100%;
        margin-top: 20px;
        .agreement {
            width: 100%;
            font-size: 12px;
            text-align: center;
            @include webkitBox(3);
            line-height: 14px;
            color: #000000;
            &:hover {
                @include color-hover();
            }
            @include media-800 {
                color: #fff;
                &:hover {
                    color: #fff;
                }
            }
        }
    }
    @include media-800 {
        display: flex;
        flex-wrap: wrap;
        background-color: #252525;
        border-radius: 0;
        box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.1);
        .condition-search {
            display: none;
        }
        .search-by-section {
            border: none;
            width: auto;
            flex: 1;
            .search-list-panel {
                top: 63px;
            }
            .search-category {
                position: relative;
                .search-input {
                    border: 1px solid #505050;
                    background-color: #252525;
                    border-right: none;
                    padding: 20px 15px 20px 30px;
                    height: 60px;
                    line-height: 17px;
                    font-size: 14px;
                    font-family: var(--font-normal);
                }
                .keyword-submit {
                    position: absolute;
                    left: 10px;
                    top: 50%;
                    transform: translateY(-50%);
                    height: 16px;
                    width: 16px;
                    background-color: transparent;
                    padding: 0;
                    .iconfont {
                        position: static;
                        transform: none;
                        line-height: 16px;
                        font-size: 16px;
                    }
                }
            }
        }
    }
}
</style>
